import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle } from "lucide-react";
const CTA = () => {
  const benefits = ["大字号 249 V100", "查看范例 3万/年", "续费 30次 V100", "API 系统级 24小时支持"];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-primary to-primary-dark text-primary-foreground">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              按页计费，更符合企业使用习惯
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              专为企业级文档处理设计，提供稳定可靠的智能翻译服务。
            </p>
            
            
          </div>

          <Card className="bg-white/10 backdrop-blur-md border-white/20 hover:bg-white/15 transition-all duration-500 hover:scale-105 hover:shadow-2xl animate-scale-in">
            <CardContent className="p-8">
              <h3 className="text-2xl font-bold text-white mb-4 animate-fade-in">立即体验</h3>
              <p className="text-muted-foreground mb-6 animate-slide-up">
                上传您的PDF文档，体验智能小语种处理的强大功能。
              </p>
              
              <div className="space-y-4 animate-fade-in" style={{
              animationDelay: '0.2s'
            }}>
                <Button size="lg" className="w-full bg-background text-foreground hover:bg-background/90 shadow-glow hover:shadow-2xl transition-all duration-300 hover:scale-105" onClick={()=> window.open("/translator", "_blank")}>
                  开始处理
                </Button>
                <Button variant="outline" size="lg" className="w-full border-primary-foreground/20 text-primary-foreground hover:bg-primary-foreground/20 hover:border-primary-foreground/40 transition-all duration-300 hover:scale-105">
                  查看API
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
};
export default CTA;